module.exports = {"meta":{"title":["{photoStyle}","{photoRoom}","in {projectLocation}","by {firmName}"]},"socialSharing":{"facebook":{"title":"Featured Project: {firmName}","description":"Tour a {projectName} on 1stdibs"},"email":{"subject":"Design Inspiration on 1stdibs","body":"Check out {firmName}'s {projectName} project on 1stdibs. {url}"},"pinterest":{"description":"See more of {firmName}'s {projectName} on 1stdibs"}}}


//////////////////
// WEBPACK FOOTER
// ./json/copy/photoGallery.json
// module id = 1021
// module chunks = 7 23 26 27